import { updateWordType } from "@/api/query/word";
import Loading from "@/common/components/Loading";
import PopUp from "@/common/components/PopUp";
import SelectInput from "@/common/components/custom/SelectInput";
import CustomSaveButton from "@/common/components/custom/buttons/CustomSaveButton";
import { WORD_LEVEL } from "@/common/constants/level.constants";
import { WORD_TYPE } from "@/common/constants/wordType.constants";
import { getToSelectData } from "@/common/functions/getToSelectData";
import { Title } from "@/pages/common/login/loginPage.styles";
import React, { useRef, useState } from "react";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  margin: 30px;
`;

const CustomButtonSubmitWrapper = styled.div`
  display: flex;
  justify-content: right;
  margin: 20px 0 -20px 0;
`;

const EditCategory = ({ setClose, edit }) => {
  const [selectedCategory, setSelectedCategory] = useState(
    getToSelectData(WORD_TYPE).find((a) => a.value === edit.type)
  );
  const { id } = useParams();

  const updateWordTypeMutation = useMutation({
    mutationFn: (value) => updateWordType(value),
    onSuccess: () => {
      setClose(null);
    },
  });

  const handleSave = (e) => {
    e && e.preventDefault();

    const payload = {};

    payload.type = selectedCategory.value;
    payload.wordId = id;

    updateWordTypeMutation.mutate(payload);
  };

  return (
    <>
      {updateWordTypeMutation.isLoading && <Loading />}
      <PopUp setClose={setClose}>
        <Wrapper onSubmit={handleSave}>
          <Title>Category Edit</Title>
          <SelectInput
            options={getToSelectData(WORD_TYPE)}
            selected={selectedCategory}
            setSelected={setSelectedCategory}
            showLabel={false}
          />
          <CustomButtonSubmitWrapper>
            <CustomSaveButton />
          </CustomButtonSubmitWrapper>
        </Wrapper>
      </PopUp>
    </>
  );
};

export default EditCategory;
